var _path, _path2, _path3, _polygon, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c1b55c66-c02c-44b5-8d97-d3cd943be37a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.97 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104,15.73H96A28.78,28.78,0,0,0,67.24,44.47V89h65.52V44.47A28.78,28.78,0,0,0,104,15.73Z",
    transform: "translate(-40.52)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.38,44.47A36.6,36.6,0,0,1,96,7.87h8a36.6,36.6,0,0,1,36.6,36.6V89h7.87V44.47A44.52,44.52,0,0,0,104,0H96A44.52,44.52,0,0,0,51.51,44.47V89h7.87Z",
    transform: "translate(-40.52)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104,7.87H96a36.6,36.6,0,0,0-36.6,36.6V89h7.86V44.47A28.78,28.78,0,0,1,96,15.73h8a28.78,28.78,0,0,1,28.74,28.74V89h7.86V44.47A36.6,36.6,0,0,0,104,7.87Z",
    transform: "translate(-40.52)",
    fill: "#afb0b0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "107.97 89.02 100.1 89.02 92.24 89.02 26.73 89.02 18.86 89.02 10.99 89.02 0 89.02 10.91 99.2 108.05 99.2 108.05 189.82 10.91 189.82 10.91 189.09 0 200 0 200 118.97 200 118.97 89.02 107.97 89.02",
    fill: "#fccc72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.43,189.82h97.14V99.2H51.43L40.52,89h0V200l10.91-10.91ZM100,123.91A12.15,12.15,0,0,1,105.27,147v21.75H94.73V147A12.15,12.15,0,0,1,100,123.91Z",
    transform: "translate(-40.52)",
    fill: "#ebb343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.84,136.07a12.15,12.15,0,0,0,6.89,11v21.75h10.54V147a12.16,12.16,0,1,0-17.43-11Z",
    transform: "translate(-40.52)",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.82340fb6ff208469d638b73fac60f99c.svg";
export { ForwardRef as ReactComponent };